<template>
  <div
    class="card mt-3"
    :style="{ 'min-height': $store.state.screenHeight - 100 + 'px' }"
  >
    <div class="card-body text-center">
      <h1 style="font-weight: bold;">รายงานยอดขายตามสินค้า</h1>
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกสาขา</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                @change="getItemGroup"
                id="Host"
                v-model="branch"
              >
                <option value="0">-- ทุกสาขา --</option>
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                >{{ b.branch_name }}</option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group row">
              <label
                class="col-sm-3 col-form-label text-right"
              >จากวันที่</label>
              <div class="col-sm-9">
                <a-date-picker
                  v-model="start_date"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group row">
              <label
                class="col-sm-3 col-form-label text-right"
              >ถึงวันที่</label>
              <div class="col-sm-9">
                <a-date-picker
                  v-model="end_date"
                  :format="'DD/MM/YYYY'"
                  style="width: 100%;"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group row">
              <label
                for="date"
                class="col-sm-3 col-form-label text-right"
              >กลุ่มสินค้าเริ่มต้น</label>
              <div class="col-sm-9">
                <div class="input-group mb-3">
                  <multiselect
                    v-model="group_start"
                    :options="group_data"
                    placeholder="เลือกสินค้าเริ่มต้น.."
                    class="multiselect"
                    label="name"
                    track-by="code"
                    ref="Item1"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group row">
              <label
                for="date"
                class="col-sm-3 col-form-label text-right"
              >กลุ่มสินค้าสิ้นสุด</label>
              <div class="col-sm-9">
                <div class="input-group mb-3">
                  <multiselect
                    v-model="group_end"
                    :options="group_data"
                    placeholder="เลือกสินค้าสิ้นสุด.."
                    label="name"
                    track-by="code"
                    ref="Item2"
                  ></multiselect>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container mt-3">
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_sale_item.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="start_date"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="end_date"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="sum_qty() === 0"
                class="btn btn-primary btn-block"
              >
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_sale_item.php"
              method="POST"
              target="_blank"
            >
              <input
                type="hidden"
                name="date_start"
                v-model="start_date"
              >
              <input
                type="hidden"
                name="date_end"
                v-model="end_date"
              >
              <input
                type="hidden"
                name="data"
                v-model="form_data"
              >
              <button
                type="submit"
                :disabled="sum_qty() === 0"
                class="btn btn-info btn-block"
              >
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
          <div class="col-sm-2"></div>
        </div>
        <div class="table-responsive-sm mt-3">
          <table
            class="table"
            v-for="(d, i) in report_data"
            :key="'d' + i"
          >
            <thead>
              <tr class="text-left">
                <th
                  colspan="7"
                  style="font-size: 20px;"
                >สาขา: {{ d.branch_name }}</th>
              </tr>
            </thead>
            <tbody
              v-for="(r, i) in d.data"
              :key="'d' + i"
            >
              <tr
                class="text-left"
                style="background: #f7f7f7;"
                v-if="r.profit.sub.length > 0"
              >
                <th colspan="6">
                  หมวดหมู่: {{ r.group_name }}
                </th>
              </tr>
              <tr
                class="text-left"
                style="background: #f7f7f7;"
                v-if="r.profit.sub.length > 0"
              >
                <th colspan="6">
                  {{ r.profit.date }}
                </th>
              </tr>
              <tr
                class="thead-dark"
                v-if="r.profit.sub.length > 0"
              >
                <th>รหัส: ชื่อ</th>
                <th width="15%">จำนวน</th>
                <th width="20%">หน่วยนับ</th>
                <th width="15%">มูลค่าขาย</th>
              </tr>
              <tr
                v-for="(sub, i) in r.profit.sub"
                v-show="r.profit.sub.length > 0"
                :key="'sub' + i"
              >
                <td class="text-left">{{ sub.item_code || '-'}}: {{ sub.item_name || '-' }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.qty) }}</td>
                <td class="text-right">{{ sub.unit_code }}</td>
                <td class="text-right">{{ numberFormatDecimal(sub.avg_cost_sale) }}</td>
              </tr>
              <tr
                style="background: #f7f7f7;"
                v-if="r.profit.sub.length > 0"
              >
                <th class="text-left">รวม</th>
                <th class="text-right">{{ numberFormatDecimal(r.profit.sum_qty) }}</th>
                <td class="text-right"></td>
                <th class="text-right">{{ numberFormatDecimal(r.profit.sum_avg_cost_sale) }}</th>
              </tr>
            </tbody>
            <tr v-if=" (d.data) ? d.data.length < 1: true">
              <th
                scope="row"
                colspan="5"
              >ไม่มีข้อมูล</th>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import moment from 'moment'
import api from '../services/service_report'
import apipos from '../services/service_pos'
import apiItem from '../services/service_item'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      host_list: [],
      host: '',
      report_data: [],
      start_date: moment(new Date()),
      end_date: moment(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      group_start: {
        name: 'ทุกกลุ่มสินค้า', code: ''
      },
      group_end: {
        name: 'ทุกกลุ่มสินค้า', code: ''
      },
      group_data: [],
      branch: 0
    }
  },
  methods: {
    getReport () {
      var branch = 0
      if (this.branch !== 0) {
        branch = this.branch.id
      }
      var obj = {
        company_id: 1,
        branch_id: branch,
        start_date: this.dateFormatDMY2(this.start_date),
        end_date: this.dateFormatDMY2(this.end_date),
        item_code: '',
        group_start: this.group_start.code,
        group_end: this.group_end.code
      }
      this.$store.state.isLoading = true
      api.saleByItem(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.state.isLoading = false
          if (result.response === 'success') {
            this.report_data = result.data.branch_sub
            this.form_data = JSON.stringify(result.data.branch_sub)
            this.form_host = JSON.stringify(this.host)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลรายงานไม่ได้',
              description: result.message
            })
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    timeFormat (str) {
      return moment(str).format('HH:mm:ss')
    },
    sum_qty () {
      var sumQty = 0
      this.report_data.forEach(val => {
        sumQty += (val['data']) ? val['data'].length : 0
      })
      return sumQty
    },
    getHost () {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === 'success') {
            this.host_list = result.data
            this.host = this.host_list[0]
            // this.getReport()
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลจุดขายไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    },
    getItemGroup () {
      var branch = 0
      if (parseInt(this.branch) === 0) {
        branch = this.$store.state.branch_list[0]
      } else {
        branch = this.branch
      }
      apiItem.itemGroup(
        branch.dyn_address + '/',
        {
          headers: {
            'Access-Token': branch.access_token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            this.group_data = [{
              name: 'ทุกกลุ่มสินค้า', code: ''
            }]
            result.data.forEach(val => {
              this.group_data.push({
                name: val['code'] + ': ' + val['name'],
                code: val['code']
              })
            })
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลสินค้าไม่ได้', result.message)
          }
        },
        error => {
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message)
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getBranch()
    this.getHost()
    setTimeout(() => {
      this.getItemGroup()
    }, 500)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/report_sale_item.vue